import { useRouteLoaderData } from 'react-router';
import { BroadbandSubscriptionTechnicalDetails } from '../../../../../components/SubscriptionDetails/BroadbandSubscriptionTechnicalDetails.js';
import { BroadbandSubscriptionLayout } from '../../../../../components/SubscriptionLayout/BroadbandSubscriptionLayout.js';
import type { MobileSubscriptionLoaderResponse } from '../../../../../common/loaders.js';

export const BroadbandSubTechnicalDetailsPath = () => {
  const { subscription, companyInfo, addOnRules, addOnRulesMobilePbx } = useRouteLoaderData(
    'broadbandSub'
  ) as MobileSubscriptionLoaderResponse;

  return (
    <BroadbandSubscriptionLayout
      addOnRules={addOnRules}
      addOnRulesMobilePbx={addOnRulesMobilePbx}
      contacts={[]}
      companyInfo={companyInfo}
      subscription={subscription}
    >
      <BroadbandSubscriptionTechnicalDetails subscription={subscription} />
    </BroadbandSubscriptionLayout>
  );
};
